import React from 'react';
import { TabList } from '@hub/tabs';
import { TabItemList } from './tab-list-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderTabs = ({
  tabsProps,
  sx,
  country
}) => {
  var _tabsProps$centre$tit, _tabsProps$centre;

  const nationalUrl = tabsProps.variant === 'centre' ? '/' : undefined;

  if (tabsProps.variant === 'national' && country === 'New Zealand') {
    return null;
  }

  return /*#__PURE__*/_jsx(TabList, {
    sx: sx,
    children: tabsProps.variant === 'gift-cards' ? /*#__PURE__*/_jsx(TabItemList, {
      tabName: "Gift cards",
      selectedColour: "brand",
      sx: {
        display: 'none'
      }
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [country === 'Australia' && /*#__PURE__*/_jsx(TabItemList, {
        tabName: "Shop online",
        selectedColour: "vibrantTeal",
        url: nationalUrl
      }), /*#__PURE__*/_jsx(TabItemList, {
        tabName: (_tabsProps$centre$tit = (_tabsProps$centre = tabsProps.centre) === null || _tabsProps$centre === void 0 ? void 0 : _tabsProps$centre.title) !== null && _tabsProps$centre$tit !== void 0 ? _tabsProps$centre$tit : 'Visit a centre',
        selectedColour: "brand"
      })]
    })
  });
};